import { OXIMETER_ALARM_DELAY } from "./ProSimulator";
import { Translate, translate } from "react-i18nify";
import { Box, Typography} from "@mui/material";
import { StringInputMenu } from "../components/UI/StringInputMenu";
import { SelectInputMenu } from "../components/UI/SelectInputMenu";
import { SelectProfileMenu } from "../components/UI/SelectProfileMenu";
import { ConfirmRiskyProfile } from "../components/UI/ConfirmRiskyProfile";
import { colors } from "../Style";

const isRiskyProfile = (profile) => {
  if (profile.minSpO2 < 85 || profile.maxPulse > 150) {
    return true;
  }
  return false;
};


export const newPatientFlow = (state, setWindowState, pageState, setPageState, defaultMenu, props, history) => {
   let popup = null;
   switch(state.windowName){
        case "newPatient":
            popup = (
                <StringInputMenu
                characters={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", " "]}
                name={"newPatient"}
                label={translate("NewPatientID")}
                target={"patient"}
                valueName={"patientId"}
                nextItem={"newName"} // KAC JAT: remove name
                value={
                    state.updated?.patient?.patientId
                    ? state.updated?.patient?.patientId
                    : parseInt(state.patient?.patientId) + 1
                }
                setState={setWindowState}
                menu={state?.window?.menu}
                onComplete={(state) =>     
                    setPageState((prev) => {
                        return {
                        ...prev,
                        updated: { patient: { patientId: state.newValue } },
                        windowName: "newNoSignalDelay",
                        window: null,
                        };
                    }
                )}
                onCancel={() => {
                    setPageState((prevState) => {
                    return {
                        ...prevState,
                        menu: { ...defaultMenu },
                        window: null,
                        updated: null,
                        windowName: null,
                    };
                    });
                }}
                state={state?.window?.state}
                />
            );
            break;

        case "newNoSignalDelay":
            popup = (
                <SelectInputMenu
                values={[
                  OXIMETER_ALARM_DELAY.OXIMETER_DELAY_30,
                  OXIMETER_ALARM_DELAY.OXIMETER_DELAY_15,
                  OXIMETER_ALARM_DELAY.OXIMETER_DELAY_5,
                  OXIMETER_ALARM_DELAY.OXIMETER_DELAY_1,
                  OXIMETER_ALARM_DELAY.OXIMETER_DELAY_0,
                ]}
                name={"noSignalDelay"}
                label={translate("SignalAlarmDelay")}
                onComplete={(newValue) => {
                    setPageState((prev) => {
                    return {
                        ...prev,
                        updated: {
                        ...prev.updated,
                        oximeterSignalAlarmDelay: newValue,
                        },
                        windowName: "selectNewProfile",
                        window: null,
                    };
                    });
                }}
                onCancel={() => {
                    setPageState((prev) => {
                    let updated = prev.updated;
                    delete updated["oximeterSignalAlarmDelay"];
                    return {
                        ...prev,
                        windowName: "newPatient",
                        window: null,
                        updated: updated,
                    };
                    });
                }}
                value={
                    state.updated?.oximeterSignalAlarmDelay
                    ? state.updated?.oximeterSignalAlarmDelay
                    : state?.oximeterSignalAlarmDelay
                }
                format={(data) => data / 60 + " min"}
                setState={setWindowState}
                menu={state?.window?.menu}
                state={state?.window?.state}
                />
            );
            break;

        case "selectNewProfile":
            popup = (
                <SelectProfileMenu
                profiles={[...props.pro.defaultProfiles]}
                name={"selectProfile"}
                label={translate("Profile")}
                lockedValues={["FlowResponse"]}
                onComplete={(profile) => {
                    if (isRiskyProfile(profile)) {
                    profile.isRisky = true;
                    setPageState((prev) => {
                        return {
                        ...prev,
                        windowName: "confirmRiskyProfileNew",
                        window: null,
                        riskyProfile: profile,
                        };
                    });
                    } else {
                    props.pro.setPatient(pageState.updated.patient);
                    // props.pro.setLocation(pageState.updated.location);
                    props.pro.setOximeterSignalAlarmDelay(
                        pageState.updated.oximeterSignalAlarmDelay
                    );
                    props.pro.setProfile(profile);
                    setPageState((prev) => {
                        return {
                        ...prev,
                        windowName: null,
                        window: null,
                        updated: null,
                        };
                    });
                    history.push({
                        pathname: "/home",
                    });
                    }
                }}
                onCancel={() => {
                    setPageState((prev) => {
                    let updated = prev.updated;
                    delete updated["profile"];
                    return {
                        ...prev,
                        windowName: "newNoSignalDelay",
                        window: null,
                        updated: updated,
                    };
                    });
                }}
                value={
                    state.updated?.oximeterSignalAlarmDelay
                    ? state.updated?.oximeterSignalAlarmDelay
                    : state?.oximeterSignalAlarmDelay
                }
                format={(data) => data}
                setState={setWindowState}
                menu={state?.window?.menu}
                state={state?.window?.state}
                />
            );
            break;
            
        case "confirmRiskyProfileNew":
          popup = (
            <ConfirmRiskyProfile
              message={
                <Typography
                  variant="h6"
                  sx={{ color: colors.COLORS_ALARM_MEDIUM, fontWeight: "bold" }}
                >
                  <Translate value={"ConfirmCritical"} />
                </Typography>
              }
              name={"confirmRiskyProfileNew"}
              onComplete={(state) => {
                props.pro.setPatient(pageState.updated.patient);
                props.pro.setLocation(pageState.updated.location);
                props.pro.setOximeterSignalAlarmDelay(
                  pageState.updated.oximeterSignalAlarmDelay
                );
                props.pro.setProfile(pageState.riskyProfile);
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: null,
                    window: null,
                    updated: null,
                  };
                });
                history.push({
                  pathname: "/home",
                });
              }}
              onCancel={() => {
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: null,
                    window: null,
                  };
                });
              }}
              setState={setWindowState}
              menu={state?.window?.menu}
              state={state?.window?.state}
            />
          );
          break;
        
   }
   return (
    <Box
      sx={{
        position: "relative",
        zIndex:505
      }}
    >
      {popup}
    </Box>
   )  
}